import { Button } from '@fluentui/react-components';
import { PageHeader } from '../../common/PageHeader';
import { DataTable } from '../../common/DataTable';
import { ErrorState } from '../../common/ErrorState';
import { LoadingState } from '../../common/LoadingState';
import { useAuditLog } from '../../../hooks/useAuditLog';
import { formatDateTime } from '../../../utils/date';
import { exportToCSV } from '../../../utils/csv';

export const AuditLogPage = () => {
  const { logs, loading, error, reload } = useAuditLog();

  const handleExport = () => {
    const now = new Date().toISOString().slice(0, 10);
    exportToCSV(
      logs as unknown as Record<string, unknown>[],
      [
        { key: 'cr_crm_entityname', label: 'Entity' },
        { key: 'cr_crm_description', label: 'Description' },
        { key: 'cr_crm_username', label: 'User' },
        { key: 'createdon', label: 'Created on' },
      ],
      `audit-log-${now}`
    );
  };

  if (loading) return <LoadingState label="Loading audit log..." />;
  if (error) return <ErrorState message={error} onRetry={() => void reload()} />;

  return (
    <div>
      <PageHeader title="Audit log" subtitle="Immutable log of sensitive user actions" actions={[{ label: 'Export CSV', onClick: handleExport, appearance: 'primary' }]} />
      <DataTable
        items={logs}
        columns={[
          { columnId: 'entity', label: 'Entity', renderCell: (item) => item.cr_crm_entityname },
          { columnId: 'description', label: 'Description', renderCell: (item) => item.cr_crm_description ?? '\u2014' },
          { columnId: 'user', label: 'User', renderCell: (item) => item.cr_crm_username ?? 'System' },
          { columnId: 'created', label: 'Created on', renderCell: (item) => formatDateTime(item.createdon) },
        ]}
        getRowId={(item) => item.cr_crm_auditlogid}
      />
      <Button appearance="subtle" style={{ marginTop: 12 }} onClick={() => void reload()}>Reload</Button>
    </div>
  );
};